'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _ramda = require('ramda');
var _reduxConnect = require('redux-connect');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRouter = require('react-router');


var _pages = require('../../pages');
var _components = require('../../components');




var _propertyDetails = require('../../redux/modules/propertyDetails');















var _favoriteProperties = require('../../redux/modules/favoriteProperties');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _messageModal = require('../../redux/modules/messageModal');



var _propertySearch = require('../../redux/modules/propertySearch');
var _reviewedPins = require('../../redux/modules/reviewedPins');

var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _propertyNotes = require('../../redux/modules/propertyNotes');
var _fetchPropertyNoteById = require('../../utils/fetchPropertyNoteById');var _fetchPropertyNoteById2 = _interopRequireDefault(_fetchPropertyNoteById);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helpers
var ProjectDetailsPage = function (_Component) {_inherits(ProjectDetailsPage, _Component);function ProjectDetailsPage() {var _temp, _this, _ret;_classCallCheck(this, ProjectDetailsPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.













    addPropertyNote = function (note) {var
      id = _this.props.projectDetails.data.id;var
      token = _this.props.userToken;

      _this.props.addPropertyNote({ noteData: { id: id, note: note }, token: token });
    }, _this.

    fetchPropertyNote = function () {var
      data = _this.props.projectDetails.data;

      if (!!data && !!data.id) {
        return (0, _fetchPropertyNoteById2.default)(data.id, _this.props.propertyNotes);
      }

      return '';
    }, _this.

    contactFormSubmitHandler = function (values) {var
      id = _this.props.projectDetails.data.id;var _this$props =
      _this.props,locale = _this$props.locale,userId = _this$props.userId;
      var additionalProps = { locale: locale, project_id: id };
      if (userId) {
        additionalProps.user_id = userId;
      }

      _this.props.sendProjectContactUsForm(Object.assign({},
      values,
      additionalProps));

    }, _this.

    handleEdit = function (event) {
      event.stopPropagation();var _this$props$projectDe =
      _this.props.projectDetails.data,id = _this$props$projectDe.id,address = _this$props$projectDe.address;
      var isForeign = (0, _checkIsForeignAddress2.default)(address);

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(
      _this.props.locale, (
      isForeign ? '/foreign_project' : '/project') + '/edit?id=' + id));

    }, _this.

    toggleFavorite = function () {
      _this.props.toggleFavorite({
        property: _this.props.projectDetails.data,
        token: _this.props.userToken,
        isProject: true });

    }, _temp), _possibleConstructorReturn(_this, _ret);}ProjectDetailsPage.prototype.componentWillMount = function componentWillMount() {if (!this.props.projectDetails.data) {this.props.receiveProperty({ id: this.props.params.id });}this.props.setPinAsReviewed(this.props.params.id);};ProjectDetailsPage.prototype.componentDidMount = function componentDidMount() {window.document.body.classList.add('overflow');};ProjectDetailsPage.prototype.componentWillUnmount = function componentWillUnmount() {window.document.body.classList.remove('overflow');};ProjectDetailsPage.prototype.

  render = function render() {var _props =









    this.props,route = _props.route,_props$projectDetails = _props.projectDetails,isLightboxOpen = _props$projectDetails.isLightboxOpen,currentImage = _props$projectDetails.currentImage,isModalContactsOpen = _props$projectDetails.isModalContactsOpen,data = _props$projectDetails.data,formSubmitting = _props$projectDetails.formSubmitting,formSubmitted = _props$projectDetails.formSubmitted,formError = _props$projectDetails.formError,locale = _props$projectDetails.locale;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    if (!data && !this.props.projectDetails.error) {
      return (
        _react2.default.createElement(_components.PropertyDetailsPlaceholder, {
          isMobile: this.props.isMobile,
          isRtl: this.props.isRtl,
          data: this.props.projectDetails.preloadData || {},
          translate: this.props.translate('propertyDetails') }));


    }

    if (!data && this.props.projectDetails.error && this.props.projectDetails.error.status === 404) {
      return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_pages.NotFoundPage, {
            locale: this.props.locale,
            translate: this.props.translate,
            rootTranslate: this.props.translate,
            isMobile: this.props.isMobile })));



    }

    var descriptionData = {
      translatedDescriptionRequired: this.props.projectDetails.translatedDescriptionRequired,
      descriptionLoaded: this.props.projectDetails.descriptionLoaded,
      translatedDescriptionText: this.props.projectDetails.translatedDescriptionText,
      showOriginalDescription: this.props.projectDetails.showOriginalDescription,
      descriptionLoading: this.props.projectDetails.descriptionLoading };


    var summaryData = {
      translatedSummaryRequired: this.props.projectDetails.translatedSummaryRequired,
      translatedSummaryText: this.props.projectDetails.translatedSummaryText,
      showOriginalSummary: this.props.projectDetails.showOriginalSummary,
      summaryLoaded: this.props.projectDetails.summaryLoaded,
      summaryLoading: this.props.projectDetails.summaryLoading };


    var isFavorite = !!data ? (this.props.favoriteProperties || []).indexOf(data.id) !== -1 : false;
    var userData = (0, _get2.default)(this.props, 'userAuthentication.data', {});

    return (
      _react2.default.createElement('div', null,
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.translate('title', 'titleTemplate')(),
          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]),

          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route }] }),


        _react2.default.createElement(_components.ProjectDetails, {
          userData: userData,
          handleEdit: this.handleEdit,
          isFavorite: isFavorite,
          toggleFavorite: this.toggleFavorite,
          preloadData: this.props.projectDetails.preloadData || {},
          routeData: this.props.routeData,
          properties: this.props.properties,
          projectProperties: this.props.projectProperties,
          receiveSimilarProjectProperties: this.props.receiveSimilarProjectProperties,
          descriptionData: descriptionData,
          toggleDescriptionTranslation: this.props.toggleDescriptionTranslation,
          detectDescriptionLanguage: this.props.detectDescriptionLanguage,
          translateDescription: this.props.translateDescription,
          resetDescriptionTranslate: this.props.resetDescriptionTranslate,
          className: 'projectDetails detailsPage',
          projectData: data,
          isModal: false,
          translate: this.props.translate,
          locale: this.props.locale,
          currentImage: currentImage,
          openLightbox: this.props.openLightbox,
          hideLightbox: this.props.hideLightbox,
          changeLightboxActiveSlide: this.props.changeLightboxActiveSlide,
          isLightboxOpen: isLightboxOpen,
          isMobile: this.props.isMobile,
          openModalContacts: this.props.openModalContacts,
          hideModalContacts: this.props.hideModalContacts,
          isModalContactsOpen: isModalContactsOpen,
          screenWidth: this.props.screenWidth,
          isRtl: this.props.isRtl,
          sendProjectContactUsForm: this.contactFormSubmitHandler,
          openMessageModal: this.props.openMessageModal,
          formSubmitting: formSubmitting,
          formSubmitted: formSubmitted,
          formError: formError,
          addPropertyNote: this.addPropertyNote,
          propertyNote: this.fetchPropertyNote(),
          userId: (0, _get2.default)(this.props, 'userId'),
          userToken: (0, _get2.default)(this.props, 'userToken'),
          summaryData: summaryData,
          toggleSummaryTranslation: this.props.toggleSummaryTranslation,
          detectSummaryLanguage: this.props.detectSummaryLanguage,
          translateSummary: this.props.translateSummary })));



  };return ProjectDetailsPage;}(_react.Component);


ProjectDetailsPage.propTypes = {
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  projectDetails: _propTypes2.default.object,
  receiveProperty: _propTypes2.default.func,
  openLightbox: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  changeLightboxActiveSlide: _propTypes2.default.func,
  params: _propTypes2.default.object,
  openModalContacts: _propTypes2.default.func,
  hideModalContacts: _propTypes2.default.func,
  screenWidth: _propTypes2.default.number,
  userToken: _propTypes2.default.string,
  route: _propTypes2.default.any,
  isRtl: _propTypes2.default.bool,
  setPinAsReviewed: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  routeData: _propTypes2.default.object,
  sendProjectContactUsForm: _propTypes2.default.func,
  properties: _propTypes2.default.array,
  projectProperties: _propTypes2.default.array,
  detectDescriptionLanguage: _propTypes2.default.func,
  translateDescription: _propTypes2.default.func,
  toggleDescriptionTranslation: _propTypes2.default.func,
  favoriteProperties: _propTypes2.default.array,
  toggleFavorite: _propTypes2.default.func,
  resetDescriptionTranslate: _propTypes2.default.func,
  userId: _propTypes2.default.string,
  receiveSimilarProjectProperties: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  propertyNotes: _propTypes2.default.array,
  translateSummary: _propTypes2.default.func,
  detectSummaryLanguage: _propTypes2.default.func,
  userAuthentication: _propTypes2.default.object,
  toggleSummaryTranslation: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(_ref) {var
  lang = _ref.lang,
  propertyDetails = _ref.propertyDetails,
  windowDimentions = _ref.windowDimentions,
  userAuthentication = _ref.userAuthentication,
  propertySearch = _ref.propertySearch,
  projectProperties = _ref.projectProperties,
  favoriteProperties = _ref.favoriteProperties,
  propertyNotes = _ref.propertyNotes;return (
    {
      userAuthentication: userAuthentication,
      translate: (0, _reduxPagan.getLang)(lang, 'static'),
      projectDetails: propertyDetails,
      favoriteProperties: favoriteProperties.favoriteIDs,
      screenWidth: windowDimentions.width,
      properties: (0, _get2.default)(propertySearch, 'similarProjectPropertiesData') || [],
      projectProperties: projectProperties.data || [],
      userToken: userAuthentication.data ? userAuthentication.data.access_token : null,
      userId: userAuthentication.data ? userAuthentication.data.id : null,
      propertyNotes: propertyNotes.data });};


var mapDispatchToProps = {
  openLightbox: _propertyDetails.openLightbox,
  hideLightbox: _propertyDetails.hideLightbox,
  changeLightboxActiveSlide: _propertyDetails.changeLightboxActiveSlide,
  receiveProperty: _propertyDetails.receiveProperty,
  openModalContacts: _propertyDetails.openModalContacts,
  hideModalContacts: _propertyDetails.hideModalContacts,
  setPinAsReviewed: _reviewedPins.setPinAsReviewed,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  sendProjectContactUsForm: _propertyDetails.sendProjectContactUsForm,
  detectDescriptionLanguage: _propertyDetails.detectDescriptionLanguage,
  receiveSimilarProjectProperties: _propertySearch.receiveSimilarProjectProperties,
  toggleDescriptionTranslation: _propertyDetails.toggleDescriptionTranslation,
  translateDescription: _propertyDetails.translateDescription,
  resetDescriptionTranslate: _propertyDetails.resetDescriptionTranslate,
  toggleFavorite: _favoriteProperties.toggleFavorite,
  addPropertyNote: _propertyNotes.addPropertyNote,
  translateSummary: _propertyDetails.translateSummary,
  detectSummaryLanguage: _propertyDetails.detectSummaryLanguage,
  toggleSummaryTranslation: _propertyDetails.toggleSummaryTranslation };exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)([{
  key: 'projectDetails',
  promise: function promise(_ref2) {var params = _ref2.params,store = _ref2.store;return store.dispatch((0, _propertyDetails.receiveProperty)({ id: params.id, target: 'projects' }));} }]),

(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
ProjectDetailsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ProjectDetailsPage/ProjectDetailsPage.js
// module id = 3096
// module chunks = 0